import React, { useState } from "react";
import { Button, Row, Col, Table, Space, message } from "antd";
import IntegrityMonitorsModal from "./IntegrityMonitorsModal";
import { removeIntegrityMonitor } from "../../../../../services/vendorProfile.services";
import { confirmModal } from "../../../../../reusable/ModalWizz";
import { IntegrityMonitorColumns } from "../../../../PQQ/tableColumns";

const IntegrityMonitors = (props) => {
  const [visible, setVisible] = useState(false);
  const [editTable, setEditTable] = useState(null);

  const refreshPage = () => {
    props.fetchIntegrityMonitor();
  };

  const openModal = (data) => {
    setVisible(true);
    setEditTable(data);
  };

  const removeColumn = (id) => {
    removeIntegrityMonitor({
      id: id,
      vendor_id: props.vendorId,
    })
      .then((response) => {
        refreshPage();
        message.success(response.data.message);
      })
      .catch((error) => {
        message.error(error.response.data.message);
      });
  };

  const columns = [
    ...IntegrityMonitorColumns,
    {
      title: "Action",
      key: "action",
      render: (record) => (
        <Space size="middle">
          <span
            className="footer-links"
            onClick={() => openModal({ ...record, status: "update" })}
          >
            Edit
          </span>
          <span
            className="footer-links"
            onClick={() => {
              confirmModal({
                title: `Are you sure to delete this record?`,
                onOk: () => removeColumn(record.id),
              });
            }}
          >
            Delete
          </span>
        </Space>
      ),
    },
  ];

  return (
    <Row>
      <Col span={22} offset={1}>
        <Button
          type="secondary"
          style={{
            marginBottom: 16,
          }}
          onClick={openModal}
        >
          Add Monitor
        </Button>
      </Col>
      <Col span={22} offset={1}>
        <Table
          size="small"
          columns={columns}
          dataSource={props.integrityMonitorData}
          pagination={false}
          scroll={{ x: 800 }}
        />
      </Col>
      {visible && (
        <IntegrityMonitorsModal
          setVisible={setVisible}
          title="Add Monitor"
          vendorId={props.vendorId}
          editTable={editTable}
          refresh={refreshPage}
        />
      )}
    </Row>
  );
};

export default IntegrityMonitors;
